import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent, WmsTreeComponent } from '@wms/components';
import { BindVariableService } from '@wms/services';

@Component({
  selector: 'wms-bind-prefab-properties',
  standalone: true,
  imports: [
    CommonModule,
    SearchComponent,
    WmsTreeComponent
  ],
  templateUrl: './bind-prefab-properties.component.html',
  styleUrls: ['./bind-prefab-properties.component.less']
})
export class BindPrefabPropertiesComponent extends BaseComponent implements OnInit {

  prefabSearchKey: any;
  bindVariableService: BindVariableService;

  constructor() {
    super();
    this.bindVariableService = inject(BindVariableService);

   }

  searchPrefabProperties($event: any) {
    this.prefabSearchKey = $event.searchKey;
  }

  ngOnInit(): void {
  }

}
